import { useQuery } from "@tanstack/react-query";
import { useDebounce } from "@uidotdev/usehooks";

import useApiHelper from "../hooks/useApiHelper";
import { OmniSearchResponse, OmniSearchType, OmniSearchVatResponse } from "../models/search/OmniSearch";

export default function useOmniSearch(query: string, type: OmniSearchType | null = null, enabled: boolean = true) {
  const { get } = useApiHelper();
  const debouncedQuery = useDebounce(query, 500);

  const searchType = type == null ? "" : String(type);

  const omniSearch = useQuery({
    queryKey: ["omniSearch", debouncedQuery, searchType],
    queryFn: () => get<OmniSearchResponse>(`/omnisearch?query=${encodeURIComponent(debouncedQuery)}&type=${encodeURIComponent(searchType)}`),
    enabled,
    staleTime: 1000 * 30,
  });

  return {
    omniSearch,
    debouncedQuery,
  };
}

// Resolves the VAT/GLOBAL indicator for the given part-backed result ids in a single
// batched call, keeping it off the hot search path.
export function useOmniSearchVat(ids: string[], enabled: boolean = true) {
  const { post } = useApiHelper();

  const sortedIds = [...ids].sort();

  const omniSearchVat = useQuery({
    queryKey: ["omniSearchVat", sortedIds],
    queryFn: () => post<{ ids: string[] }, OmniSearchVatResponse>("/omnisearch/vat", { ids: sortedIds }),
    enabled: enabled && sortedIds.length > 0,
    staleTime: 1000 * 60,
  });

  return {
    omniSearchVat,
  };
}
